import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  inProduction: null,
};

export type InProductionButton = Readonly<typeof initialState>

export const slice = createSlice({
  name: 'inProductionButton',
  initialState,
  reducers: {
    changeStateProduction(state, action) {
      state.inProduction = action.payload;
    }
  }
});

// Reducer
export const { changeStateProduction } = slice.actions;
export default slice.reducer;
